/**
 * Chinese Technology Translations
 * 技术页翻译模块 - 中文
 * 
 * 包含红外技术原理、技术优势、科学原理等翻译
 */

import type { TechnologyTranslations } from '../../types';

export const zhTechnology: TechnologyTranslations = {
  title: '温暖新科技',
  subtitle: '探索远红外科技，体验高效舒适的温暖',
  section1: {
    title: '如阳光般，温暖满屋',
    desc1: '传统取暖器主要加热空气，热气流上升至天花板，不仅导致室温冷热不均，还会搅动空气中的灰尘。',
    desc2: '远红外取暖原理截然不同。它像太阳一样，发射电磁波直接温暖物体和人体。墙壁、地板和家具在吸收热量后会缓慢释放，从而让整个空间保持恒温舒适。',
    radiant: '辐射传热',
  },
  section2: {
    title: '核心取暖技术',
    intro: '我们特别设计的加热元件，结合我们的专利纳米涂层，提供卓越的取暖性能。',
    surface: '纳米涂层',
    surfaceDesc: '专利纳米涂层显著增加辐射面积，发射率达86%。',
    rapid: '快速升温',
    rapidDesc: '高导热铝材5分钟即可达到最佳温度。',
    durability: '超长寿命',
    durabilityDesc: '设计寿命25年以上，免维护运行。',
    nanoTitle: '纳米技术',
  },
  infraredIntroduction: {
    title: '先进远红外技术',
    desc: '利用光谱中的不可见光，实现卓越的热效率。我们的技术通过优化远红外波段，让人体对热量的吸收达到极致。',
    optimalWavelength: '最佳波长',
    optimalWavelengthDesc: '调谐至能与人体水分子产生自然共振的特定频率，确保热量被最大程度地吸收并牢牢锁住。',
    superiorEfficiency: '卓越效能',
    superiorEfficiencyDesc: '性能超越近红外和中红外波段。远红外线能柔和、均匀地供热，没有强烈的炙烤感，也不会导致空气干燥。',
    radiantEnergy: '辐射能量',
    radiantEnergyDesc: '释放纯净的辐射热，直达物体和人体，无需依赖空气循环传热，从而杜绝能量浪费。',
  },
  healthBenefits: {
    title: '超越取暖：健康益处',
    desc: '远红外线不仅仅用于保暖；其独特的波长能营造更健康、舒适的环境，主动呵护您的身心健康。',
    card1: {
      title: '"生命之光"',
      desc: '运行在 8-15 微米波段，这种热量能与人体自身的频率自然匹配。由此产生的温暖温和且能被深层吸收，感觉浑然天成。',
    },
    card2: {
      title: '洁净呼吸',
      desc: '不同于传统的对流取暖器，它不会扬起灰尘、扩散过敏原或让空气变得干燥，从而有效保护您的皮肤和呼吸系统健康。',
    },
    card3: {
      title: '深层舒缓暖意',
      desc: '具有深层穿透力的热波有助于促进微循环，能够舒缓肌肉，缓解冬季带来的身体僵硬感。',
    },
  },
};
